module.exports = __webpack_public_path__ + "img/1.264e406f.jpeg";